var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,12c0,0.5-0.5,1-1,1H6.4l2.3,2.3c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0l-4-4c-0.4-0.4-0.4-1,0-1.4l4-4C7.5,7.1,7.7,7,8,7 s0.5,0.1,0.7,0.3c0.4,0.4,0.4,1,0,1.4L6.4,11H20C20.5,11,21,11.5,21,12z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,7h-8.4c-0.6,0-1-0.4-1-1s0.4-1,1-1H20c0.6,0,1,0.4,1,1S20.6,7,20,7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,19h-8.4c-0.6,0-1-0.4-1-1s0.4-1,1-1H20c0.6,0,1,0.4,1,1S20.6,19,20,19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuCollapse);
export default __webpack_public_path__ + "static/media/icon-menu-collapse.b64e07ed9409806ab80daea68e16c54d.svg";
export { ForwardRef as ReactComponent };